module.exports = require("axios/lib/helpers/buildURL");